// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listItemGlosarry {
  cursor: pointer;
  padding: 16px;
  margin: 8px 0;
}
.listItemGlosarry .boxMargin {
  margin-bottom: 16px;
}
.listItemGlosarry .boxItem {
  display: flex;
  align-items: center;
  margin-right: 8px;
  gap: 8px;
  margin-top: 8px;
}
.listItemGlosarry .boxItem .bulletItem {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.listItemGlosarry .textRole {
  font-family: "IliaOpenSans";
  color: #1c1d38;
  font-weight: 700;
  font-size: 24px;
  height: 20px;
  width: 988px;
  line-height: 32.68px;
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/template/base-template/glossaryList/glossaryList.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACF,aAAA;AACF;AAAI;EACI,mBAAA;AAER;AAAI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACJ,eAAA;AAEJ;AADQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAGZ;AAAI;EACI,2BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAER","sourcesContent":[".listItemGlosarry {\n    cursor: pointer;\n    padding: 16px;\n\t\tmargin: 8px 0;\n    .boxMargin {\n        margin-bottom: 16px;\n    }\n    .boxItem {\n        display: flex;\n        align-items: center;\n        margin-right: 8px;\n        gap: 8px;\n\t\t\t\tmargin-top: 8px;\n        .bulletItem {\n            width: 12px;\n            height: 12px;\n            border-radius: 50%;\n        }\n    }\n    .textRole {\n        font-family: \"IliaOpenSans\";\n        color: #1c1d38;\n        font-weight: 700;\n        font-size: 24px;\n        height: 20px;\n        width: 988px;\n        line-height: 32.68px;\n        margin-bottom: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
